import { Route, Routes } from 'react-router-dom';
import { NotFound, DevolutionInvoices } from '@pages';
import Protected from '@components/Protected';

function RoutesDevolutionInvoices() {
  return (
    <Protected>
      <Routes>
        <Route index element={<DevolutionInvoices />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Protected>
  );
}

export default RoutesDevolutionInvoices;
